import {
    IExternalUserResponse,
    IRegisterFromCPFUserRequest,
} from "@finbackoffice/clientbff-client";
import {
    Dispatch,
    FC,
    PropsWithChildren,
    SetStateAction,
    createContext,
    useMemo,
    useState,
} from "react";

type StepType = "first" | "second" | "complete" | "recovery";

export interface INewRegisterUser
    extends Partial<IRegisterFromCPFUserRequest>, Partial<IExternalUserResponse> {
    token?: string | null;
}

type ICpfSignupContext = {
    setStep: (step: StepType) => void;
    step: StepType;
    newRegisterUser: INewRegisterUser | undefined;
    setNewRegisterUser: Dispatch<SetStateAction<INewRegisterUser | undefined>>;
};

export const CpfSignupContext = createContext<ICpfSignupContext>({} as ICpfSignupContext);

export const CpfSignupProvider: FC<PropsWithChildren> = ({ children }) => {
    const [newRegisterUser, setNewRegisterUser] = useState<INewRegisterUser | undefined>();
    const [step, setStep] = useState<StepType>("first");

    const value = useMemo(
        () => ({
            setStep,
            step,
            newRegisterUser,
            setNewRegisterUser,
        }),
        [setStep, step, newRegisterUser, setNewRegisterUser],
    );

    return <CpfSignupContext.Provider value={value}>{children}</CpfSignupContext.Provider>;
};
